import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { api } from "@/lib/api";
import { Badge, PAYMENT, PAY_STATUS, Loading, fmtDate, fmtEur } from "@/admin/ui";

export default function PaymentDrawer({ id, onClose }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    setP(null);
    if (id) api.get(`/admin/payments/${id}`).then((r) => setP(r.data)).catch(() => setP(false));
  }, [id]);
  return (
    <Sheet open={!!id} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full sm:max-w-md overflow-y-auto bg-white text-[#10151C]" data-testid="admin-payment-drawer">
        <SheetHeader><SheetTitle>Detalle del pago</SheetTitle></SheetHeader>
        {p === null ? <Loading /> : p === false ? <p>No se pudo cargar el pago.</p> : (
          <div style={{ marginTop: "1.25rem", fontSize: 14 }}>
            <dl className="adm-dl">
              <dt>ID</dt><dd style={{ wordBreak: "break-all", fontFamily: "var(--mono)", fontSize: 12 }} data-testid="admin-payment-ref">{p.ref}</dd>
              <dt>Estado</dt><dd><Badge map={PAYMENT} value={p.status} /></dd>
              <dt>Importe</dt><dd>{fmtEur(p.amount)}</dd>
              <dt>Tipo</dt><dd>{p.kind === "renovación" ? "Renovación" : "Alta"}{p.plan_name ? ` · ${p.plan_name}` : ""}</dd>
              <dt>Método</dt><dd>{p.method || "—"}</dd>
              <dt>Intentos</dt><dd data-testid="admin-payment-attempts">{p.attempts}</dd>
              <dt>Fecha</dt><dd>{fmtDate(p.created_at, true)}</dd>
            </dl>
            <div className="adm-panel-h" style={{ marginTop: "1.75rem" }}>
              <h2>{p.name}</h2>
              {p.student_status && <Badge map={PAY_STATUS} value={p.student_status} />}
            </div>
            <p className="adm-sub" style={{ marginTop: "-.5rem" }}>{p.email}</p>
            <h3 style={{ fontSize: 13, margin: "1rem 0 .3rem" }}>Historial del alumno</h3>
            {p.history.map((h) => (
              <div key={h.id} className="adm-list-item" data-testid={`admin-payment-history-${h.id}`}>
                <span className="adm-sub">{fmtDate(h.created_at)}</span>
                <span className="adm-row"><b>{fmtEur(h.amount)}</b><Badge map={PAYMENT} value={h.status} /></span>
              </div>
            ))}
            {p.email && <Link to={`/admin/alumnos/${p.user_id}`} className="adm-btn" style={{ marginTop: "1.25rem" }} data-testid="admin-payment-student-link">Ver ficha del alumno</Link>}
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
